export const SET_MEDIA = "SET_MEDIA";

export const setMedia = (media) => {
  return {
    type: SET_MEDIA,
    payload: media,
  };
};
